import React, { useContext } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { LogAnalyticsEvent } from '../../../utils/firebase/firebase';
import { ANALYTICS_KEYS } from '../../../constants/AnalyticKeys';
import { UIContext } from '../../../contexts/UIProvider';
import { useNavigate } from 'react-router-dom';

const Submenu = ({ isSelected, item, isDrawerExpanded, isHovering }) => {
  const { updateSelectedMenu } = useContext(UIContext);
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [openedByClick, setOpenedByClick] = React.useState(false);
  const [hovered, setHovered] = React.useState(false);

  const handleItemClick = (item) => {
    const newOpen = !open;
    setOpen(newOpen);
    setOpenedByClick(newOpen);
    updateSelectedMenu(item.key);
    LogAnalyticsEvent(ANALYTICS_KEYS.LEFTMENU.SIDEBARMENUCLICK, {
      page_name: item.name,
      is_open: newOpen,
    });
    if (item.path) navigate(item.path);
  };

  const handleMouseEnter = () => {
    setHovered(true);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setHovered(false);
    if (!openedByClick) {
      setOpen(false);
    }
  };

  const handleSubitemClick = (subitem) => {
    updateSelectedMenu(item.key);
    LogAnalyticsEvent(ANALYTICS_KEYS.LEFTMENU.SIDEBARMENUCLICK, {
      page_name: subitem.name,
      is_open: false,
    });
    navigate(subitem.path);
  };

  const isExpanded = isDrawerExpanded || hovered || open;

  return (
    <>
      <ListItemButton
        onClick={() => handleItemClick(item)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{ width: '100%' }}
      >
        <ListItemIcon
          sx={{ color: 'var(--clr-theme-purple)' }}
          className={isSelected ? 'selectedIcon' : 'nonSelectedIcon'}
        >
          {item.icon}
        </ListItemIcon>
        {(isDrawerExpanded || isHovering) && (
          <ListItemText
            primary={item.name}
            sx={{ color: 'var(--clr-theme-gray-dark)' }}
          />
        )}
        {open ? (
          <ExpandLess sx={{ color: 'var(--clr-theme-gray-dark)' }} />
        ) : (
          <ExpandMore sx={{ color: 'var(--clr-theme-gray-dark)' }} />
        )}
      </ListItemButton>
      <Collapse
        in={open}
        timeout='auto'
        unmountOnExit
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <List
          component='div'
          disablePadding
          className='collapsedList'
          sx={{
            overflowX: isExpanded ? 'auto' : 'hidden',
            width: isExpanded ? 'auto' : 50,
          }}
        >
          {item.submenu?.map((subitem) => (
            <ListItemButton
              key={subitem.key}
              sx={{
                pl: isExpanded ? 2 : 1.5,
                width: isExpanded ? '100%' : 45,
              }}
              onClick={() => handleSubitemClick(subitem)}
            >
              <ListItemIcon
                className={isSelected ? 'selectedIcon' : 'nonSelectedIcon'}
                sx={{
                  justifyContent: isExpanded ? 'auto' : 'left',
                  width: isExpanded ? 'auto' : 40,
                }}
              >
                {subitem.icon}
              </ListItemIcon>
              {isExpanded && (
                <ListItemText
                  primary={subitem.name}
                  sx={{ color: 'var(--clr-theme-gray-dark)' }}
                />
              )}
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
};

export default Submenu;
